export class PublicRelations {}
